// extracted by mini-css-extract-plugin
export default {"phoneParam":"SingleParam_phoneParam__Sb2fQ","phoneParam__name":"SingleParam_phoneParam__name__vXNG4","phoneParam__overview":"SingleParam_phoneParam__overview__TdVvI"};